<form class="login-form" [formGroup]="subscriptionForm" *ngIf="formSuccessMessage == null" (ngSubmit)="registerEmail()">
  <div class="input-group submit-div" [ngClass]="{'is-invalid': showEmailError}">
    <span class="input-group-text email-icon-input" id="basic-addon1"><img alt="envelop-icon" i18n-alt src="assets/envelop-icon.svg" /></span>
    <input type="email" class="form-control email-input" id="email" placeholder="Enter your email" i18n-placeholder aria-label="email" formControlName="email" aria-describedby="email-help">
    <button class="btn submit-button" type="submit" id="button-addon2" *ngIf="!loadingSubscriptionForm" i18n>Submit</button>
    <button class="btn btn-primary submit-button" type="button" disabled *ngIf="loadingSubscriptionForm">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      <span class="visually-hidden" role="status" i18n>Loading...</span>
    </button>
  </div>
  <div class="invalid-feedback" *ngIf="showEmailError">
    <div i18n *ngIf="email?.hasError('required')">Email is required.</div>
    <div i18n *ngIf="email?.hasError('email')">Incorrect email format.</div>
    <div *ngIf="emailServerError != null">{{ emailServerError }}</div>
  </div>
</form>
<div class="alert alert-success form-alert" *ngIf="formSuccessMessage">
  <div *ngIf="formSuccessMessage != null">{{ formSuccessMessage }}</div>
</div>
